import React from 'react';
import { Link } from '@99designs/emu';
import { publicImageUrl } from '../../../lib/publicImageUrl';

interface Props {
    partner: Partner;
}

interface Partner {
    learnMoreLink: string;
    image: Image;
}

interface Image {
    url: string;
    alt: string;
}

export default function ParneterImage({ partner }: Props) {
    return (
        <Link href={partner.learnMoreLink} target="_blank" rel="noreferrer">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={publicImageUrl(partner.image.url)} alt={partner.image.alt} />
        </Link>
    );
}
